import { render, staticRenderFns } from "./TwoFA.vue?vue&type=template&id=980e5d24"
import script from "./TwoFA.vue?vue&type=script&lang=js"
export * from "./TwoFA.vue?vue&type=script&lang=js"
import style0 from "./TwoFA.vue?vue&type=style&index=0&id=980e5d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports